import { SendOutlined } from "@ant-design/icons";
import { Button, InputRef } from "antd";
import TextArea from "antd/es/input/TextArea";
import AvatarInitials from "components/AvatarInitials";
import React from "react";
import { UserInfo } from "store/user/userConstants";

type PostCommentInputProps = {
  currentUser: UserInfo;
  commentBody: string;
  setCommentBody: (value: string) => void;
  loading: "comment" | false; // Only concerned with comment loading state here
  saveComment: () => Promise<void>;
  handleKeyDown: (key: string, shiftKey: boolean) => void;
  bodyInputRef: React.RefObject<InputRef>;
};

const PostCommentInput = ({
  currentUser,
  commentBody,
  setCommentBody,
  loading,
  saveComment,
  handleKeyDown,
  bodyInputRef,
}: PostCommentInputProps) => {
  return (
    <>
      <AvatarInitials size="small" user={currentUser} />
      <TextArea
        className="!min-h-6"
        size="small"
        autoSize
        ref={bodyInputRef}
        value={commentBody}
        readOnly={loading === "comment"}
        placeholder="Add a comment"
        onChange={({ target }) => setCommentBody(target.value)}
        onKeyDown={({ key, shiftKey }) =>
          !loading && handleKeyDown(key, shiftKey)
        }
      />
      <Button
        size="small"
        className="ant-btn-small-fix mt-auto"
        icon={<SendOutlined />}
        disabled={!commentBody}
        loading={loading === "comment"}
        onClick={saveComment}
      />
    </>
  );
};

export default PostCommentInput;
